export default {
  change: '更换',
  resetPassword: '重置密码',
  cancelEdit: '取消编辑',
  editInfo: '编辑信息',
  userId: '用户ID',
  email: '邮箱地址',
  phone: '手机号码',
  company: '所属公司',
  lastLogin: '最后登录',
  registerTime: '注册时间',
  save: '保存更改',
  cancel: '取消',
  thirdPartyBind: '第三方账号绑定',
  notBound: '未绑定账号',
  bound: '已绑定',
  unbound: '未绑定',
  unbind: '解绑',
  toBind: '去绑定',
  verifyMethod: '验证方式',
  phoneVerify: '手机号验证',
  emailVerify: '邮箱验证',
  code: '验证码',
  sendCode: '发送验证码',
  newPassword: '新密码',
  confirmPassword: '确认新密码',
  username: '用户名',
  needVerify: '需验证',
  passwordMin: '密码至少6位',
  passwordNotMatch: '两次输入的密码不一致',
  validPhone: '请输入有效的手机号',
  inputUsername: '请输入用户名',
  usernameMin: '用户名至少2个字符',
  usernameMax: '用户名不能超过50个字符',
  inputEmail: '请输入邮箱',
  validEmail: '请输入有效的邮箱地址',
  emailMax: '邮箱不能超过100个字符',
  inputPhone: '请输入手机号',
  phoneMax: '手机号不能超过20个字符',
  inputCompany: '请输入所属公司',
  inputCode: '请输入验证码',
  inputNewPassword: '请输入新密码',
  inputConfirmPassword: '请确认新密码',
  updateSuccess: '用户信息更新成功',
  updateFail: '用户信息更新失败',
  fetchFail: '获取用户信息失败',
  sendCodeFail: '发送验证码失败',
  resetSuccess: '密码重置成功',
  resetFail: '密码重置失败',
  avatarTodo: '头像上传功能待实现',
  avatarTypeError: '请选择图片文件',
  avatarSizeError: '头像文件大小不能超过5MB',
  avatarUploadSuccess: '头像上传成功',
  avatarUploadFail: '头像上传失败',
  superAdmin: '超级管理员',
  user: '普通用户',
  statusActive: '正常',
  statusInactive: '禁用',
  statusPending: '待激活',
  verifyTitle: '验证',
  verifyStepSend: '发送验证码',
  verifyStepCheck: '验证身份',
  verifySendTip: '检测到您修改了{field}，需要验证新的{field}才能保存更改。',
  verifySendTo: '将向以下{field}发送验证码：',
  verifyCodeLabel: '验证码',
  verifyCodePlaceholder: '请输入6位验证码',
  verifyCodeSent: '验证码已发送',
  verifyResend: '{countdown}s后重发',
  verifyResendBtn: '重新发送',
  verifyAndSave: '验证并保存',
  verifySuccess: '验证成功',
  verifyFail: '验证码错误',
  verifySendSuccess: '验证码已发送至 {target}',
  verifyNext: '下一步',
  verifyPrev: '上一步',
  verifyCancel: '取消',
  personalEmailTitle: '个人发件邮箱',
  personalEmailTip: '邮件模板选择“操作人个人邮箱”时，将使用这里保存的 SMTP 配置，并以您个人资料中的邮箱地址发件。',
  personalEmailSender: '发件邮箱',
  personalEmailSenderName: '发件人名称',
  personalEmailSenderNamePlaceholder: '留空时使用个人资料姓名',
  personalEmailSenderNameMaxLength: '发件人名称不能超过100个字符',
  personalEmailSmtpServer: 'SMTP 服务器',
  personalEmailSmtpServerRequired: '请输入 SMTP 服务器',
  personalEmailSmtpServerMaxLength: 'SMTP 服务器不能超过255个字符',
  personalEmailSmtpPort: 'SMTP 端口',
  personalEmailSmtpPortRequired: '请输入 SMTP 端口',
  personalEmailEncryption: '加密方式',
  personalEmailSmtpAccount: 'SMTP 账号',
  personalEmailSmtpAccountPlaceholder: '留空时使用发件邮箱',
  personalEmailSmtpAccountMaxLength: 'SMTP 账号不能超过255个字符',
  personalEmailSmtpPassword: 'SMTP 密码/授权码',
  personalEmailSmtpPasswordRequired: '请输入 SMTP 密码或授权码',
  personalEmailSmtpPasswordMaxLength: 'SMTP 密码或授权码不能超过500个字符',
  personalEmailSmtpPasswordPlaceholder: '请输入 SMTP 密码或授权码',
  personalEmailSmtpPasswordSaved: '已保存；留空表示不修改',
  personalEmailStatus: '启用个人邮箱',
  personalEmailSignatureEnabled: '启用邮件签名',
  personalEmailSignature: '邮件签名（HTML）',
  personalEmailSave: '保存个人邮箱',
  personalEmailTest: '发送测试邮件',
  personalEmailNotTested: '未测试',
  personalEmailTestSuccess: '测试通过',
  personalEmailTestFailed: '测试失败',
  personalEmailFetchFailed: '获取个人邮箱配置失败',
  personalEmailSaveSuccess: '个人邮箱配置已保存',
  personalEmailSaveFailed: '个人邮箱配置保存失败',
  personalEmailTestMailSent: '测试邮件已发送至您的邮箱'
}
